import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@admin/environments/environment';

import { InsurancePackage, InsurancePackageConfigPayload, InsurancePackagePayload } from '@lib/core/models/insurance-package.interface';

@Injectable({ providedIn: 'root' })
export class InsurancePackageService {
  private readonly http = inject(HttpClient);

  getInsurancePackages() {
    return this.http.get<InsurancePackage[]>(`${environment.packagesApiUrl}/packages`);
  }

  getInsurancePackageById(packageId: string) {
    return this.http.get<InsurancePackage>(`${environment.packagesApiUrl}/packages/${packageId}`);
  }

  createInsurancePackage(payload: InsurancePackagePayload) {
    return this.http.post<InsurancePackage>(`${environment.packagesApiUrl}/packages`, payload);
  }

  createEmptyInsurancePackage() {
    return this.http.post<InsurancePackage>(`${environment.packagesApiUrl}/packages/empty`, {});
  }

  deleteEmptyInsurancePackage(packageId: string) {
    return this.http.delete<InsurancePackage>(`${environment.packagesApiUrl}/packages/unactivated/${packageId}`);
  }

  editInsurancePackage(id: string, payload: InsurancePackagePayload) {
    return this.http.put<InsurancePackage>(`${environment.packagesApiUrl}/packages/${id}`, payload);
  }

  updateInsurancePackageConfig(packageId: string, payload: InsurancePackageConfigPayload) {
    return this.http.put(`${environment.packagesApiUrl}/packages/${packageId}/config`, payload);
  }

  deactivateInsurancePackage(id: string) {
    return this.http.delete<void>(`${environment.packagesApiUrl}/packages/${id}`);
  }

  activateInsurancePackage(id: string, payload: InsurancePackage) {
    return this.http.post<InsurancePackage>(`${environment.packagesApiUrl}/packages/${id}/activate`, {
      packageId: id,
      startDate: payload.startDate,
      endDate: payload.endDate,
    });
  }
}
